import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContainerTooltip = styled(Grid)({
  padding: "4px 8px",
  gap: "10px",
});

export const TextInfo = styled(Grid)({
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "24px",
  fontFamily: "Manrope",
  color: "#FFFFFF",
  maxWidth: 370,
  fontStyle: "normal",
  padding: 0,
  margin: 0,
});
